import { StyleSheet } from 'aphrodite';
import { titles } from '../../../web/styles/colors';
import { BreakPoints, CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {},
	header: {
		alignItems: 'center',
		background: '#f9f9f9',
		borderRadius: '8px 8px 0 0',
		display: 'flex',
		height: 110,
		justifyContent: 'center',
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				fontSize: 16,
				margin: '14px 0 0 0',
			},
			':not(:first-child)'
		),
	},
	heading: {
		fontSize: 24,
		margin: 0,
	},
	surveyContent: {
		border: 'none',
	},
	surveyResponseSubmitted: {
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 14,
		height: '100%',
		margin: '0 auto',
		padding: '100px 0',
		width: '64%',
		...CssSelectors.allChildren(
			{
				marginBottom: 50,
			},
			':not(:last-child)'
		),
		[BreakPoints.phoneCompactWidth]: {
			paddingTop: 76,
		},
	},
	unavailable: {
		alignItems: 'center',
		color: '#858585',
		display: 'flex',
		flexDirection: 'column',
		fontSize: 18,
		height: '100%',
		justifyContent: 'center',
		minHeight: 'calc(100vh - 200px)',
		...CssSelectors.allChildren(
			{
				marginBottom: 40,
			},
			':not(:last-child)'
		),
	},
});
